export const eVerifyStatuses = [
    {name:'Select', id: 0},
    {name:'Pending E-Verification', id: 1},
    {name:'Employment Authorized', id: 2},
    {name:'E-Verify Needs More Time', id: 3},
    {name:'Tentative Non-Confirmation', id: 4},
    {name:'Case in Continuance', id: 5},
    {name:'Close Case and Resubmit', id: 6},
  ];